import React, { useEffect, useState } from "react";
import OutlinedFormInput from "../OutlinedFormInput/OutlinedFormInput";
import styles from './MultiTagInputField.module.scss';
import { IoMdClose as CloseIcon } from 'react-icons/io'

const MultiTagInputField = ({ fieldProps, fieldLabel, fieldPlaceholder }) => {
  const [inputValue, setInputValue] = useState('');
  const [items, setItems] = useState<string[]>(fieldProps?.input?.value ?? []);

  useEffect(() => {
    fieldProps.input.onChange(items)
  }, [items])

  const handleAddItem = (value: string) => {
    const trimmed = value.trim();
    if (trimmed && !items.includes(trimmed)) {
      setItems([...items, trimmed]);
      setInputValue('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', ',', 'Tab'].includes(e.key)) {
      e.preventDefault();
      handleAddItem(inputValue);
    }
  };

  const handleBlur = () => {
    handleAddItem(inputValue);
    fieldProps.input.onBlur()
  };


  // console.log('items', items);
  return (
    <div>

      <>
        <OutlinedFormInput
          {...fieldProps.input}
          label={fieldLabel}
          fieldType='lg'
          placeholder={fieldPlaceholder}
          name={fieldProps.input.name}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleBlur}
          error={fieldProps.meta.error}
          touched={fieldProps.meta.touched}
          inpuType="text"
          onKeyDown={handleKeyDown}
          maxLength={100}
        />
        {items?.length ? <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {items.map((item, idx) => (
            <div className={styles.chipsContainer}>
              <div className={styles.chipsTitleContainer}>
                <div className={styles.chipTitle}>
                  {item}
                </div>
              </div>
              <div style={{ cursor: "pointer" }} className={styles.removeContainer} onClick={() => setItems(items.filter((_, i) => i !== idx))}>
                <CloseIcon />
              </div>
            </div>
          ))}
        </div> : null}
      </>
    </div>
  );
};

export default MultiTagInputField;